export const max2Decimal: RegExp = /^\d*(\.)?(\d{1,2})?$/;
export const max4Decimal: RegExp = /^\d*(\.)?(\d{1,4})?$/;
export const validDecimalNumber: RegExp = /^\d+(\.\d{1,8})?$/;
;